import { apiSlice } from "../../../api/apiSlice";
import { DELETE_ACTION_PLAN, GET_ACTIVE_ACTION_PLANS, GET_COACHING_ACTION_PLANS, GET_SUPERVISORS_BY_MANAGER } from "../../../constants";


export const activeActionPlansSlice : any = apiSlice.injectEndpoints({
    endpoints: (builder: any) => ({
        getActiveActionPlans: builder.query({
            query: (args: any) => {
                const { employeeNumber,scorecardVersionId } = args;
                return {
                    url: GET_ACTIVE_ACTION_PLANS,
                    params: { employeeNumber,scorecardVersionId },
                };
            },
            providesTags: ['CoachingActionSession'],
        }),
        getCoachingActionPlans: builder.query({
            query: (args: any) => {
                const { employeeNumber,scorecardVersionId, fromDate, toDate } = args;
                return {
                    url: GET_COACHING_ACTION_PLANS,
                    params: { employeeNumber,scorecardVersionId, fromDate, toDate },
                };
            },
            providesTags: ['CoachingActionSession'],
        }),
        getSupervisorsByManager: builder.query({
            query: (args: any) => {
                const { employeeNumber, includeHierarchy } = args;
                return {
                    url: GET_SUPERVISORS_BY_MANAGER,
                    params: { employeeNumber, includeHierarchy },
                };
            },
        }),
        deleteActionPlan: builder.mutation({
            query: (actionPlanId: number) => ({
                url: DELETE_ACTION_PLAN,
                method: 'PUT',
                params: { actionPlanId },
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                },
            }),
            invalidatesTags: ['CoachingActionSession'],
        }),
    }),
});

export const {
    useGetActiveActionPlansQuery,
    useGetCoachingActionPlansQuery,
    useGetSupervisorsByManagerQuery,
    useDeleteActionPlanMutation,
} = activeActionPlansSlice;
